module.exports = __webpack_public_path__ + "static/media/03.1cb3d3c1.png";